window.Sparkle ??= {};
window.Sparkle.LocationBrowser ??= {};
window.Sparkle.LocationBrowser.Models ??= {};

Sparkle.LocationBrowser.Models.Location = class Location extends Backbone.Model {
  constructor() {
    super(...arguments);
    this.isWithinDistance = this.isWithinDistance.bind(this);
    this.addressesWithinDistance = this.addressesWithinDistance.bind(this);
    this.hasChildrenWithinDistance = this.hasChildrenWithinDistance.bind(this);
    this.toJSON = this.toJSON.bind(this);
    this.children = this.children.bind(this);
    this.parent = this.parent.bind(this);
    this.isRoot = this.isRoot.bind(this);
    this.hasChildren = this.hasChildren.bind(this);
    this.hasAddress = this.hasAddress.bind(this);
    this.distance = this.distance.bind(this);
    this.filterAddresses = this.filterAddresses.bind(this);
    this.addressDistance = this.addressDistance.bind(this);
    this.rangeInMeters = this.rangeInMeters.bind(this);
  }

  isWithinDistance() {
    let within = true;

    if (this.collection.searchParams != null ? this.collection.searchParams.range : undefined) {
      within = this.rangeInMeters() >= this.distance();
    } else if (this.collection.searchParams != null ? this.collection.searchParams.zip : undefined) {
      within = this.filterAddresses("zip", (address, zip) => address.zip_code === zip).length;
    }

    return within || this.hasChildrenWithinDistance();
  }

  addressesWithinDistance() {
    if (this.collection.searchParams != null ? this.collection.searchParams.zip : undefined) {
      return this.filterAddresses("zip", (address, zip) => address.zip_code === zip);
    } else {
      return this.filterAddresses("range", (address, range) => this.rangeInMeters() >= this.addressDistance(address));
    }
  }

  hasChildrenWithinDistance() {
    return typeof _.any === "function" ? _.any(this.children(), (child) => child.isWithinDistance()) : undefined;
  }

  toJSON() {
    const json = super.toJSON(...arguments);
    json.child_ids = _.pluck(this.children(), "id");
    return json;
  }

  children() {
    return this.collection.where({ parent_id: this.id });
  }

  parent() {
    if (!this.isRoot()) {
      return this.collection.findWhere({ id: this.get("parent_id") });
    }
  }

  isRoot() {
    return this.get("parent_id") == null;
  }

  hasChildren() {
    return this.collection.some({ parent_id: this.id });
  }

  hasAddress() {
    return this.get("addresses").length;
  }

  distance() {
    const addresses = _.sortBy(this.get("addresses"), (address) => (address.distance = this.addressDistance(address)));
    return addresses[0] != null ? addresses[0].distance : undefined;
  }

  // Pass search params required for the filter, and a filter function to which the address and params will be yielded
  filterAddresses(...args1) {
    const adjustedLength = Math.max(args1.length, 1);
    const params = args1.slice(0, adjustedLength - 1);
    const filterFunction = args1[adjustedLength - 1];
    const addresses = this.get("addresses");
    const args = [];
    const { searchParams } = this.collection;

    // If any of the required params are not present, return an unfiltered list
    if (
      !searchParams ||
      !_.all(params, (param) => {
        if (searchParams[param]) {
          return args.push(searchParams[param]);
        }
      })
    ) {
      return addresses;
    }

    return _.filter(addresses, (address) => filterFunction(address, ...Array.from(args)));
  }

  addressDistance(address) {
    return google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(address.lat, address.lng),
      this.collection.searchParams.googleLatLng,
    );
  }

  rangeInMeters() {
    return this.collection.searchParams.range * this.METERS_PER_MILE;
  }
};
Sparkle.LocationBrowser.Models.Location.prototype.METERS_PER_MILE = 1609.4;
